module.exports = __webpack_public_path__ + "assets/img/keyword-search-list.ce979490.svg";